import { MapperSend } from "@shared/interfaces/mapper";

export interface IImagenURLDTO {
    image_url: string;
}

export class ImagenURLDTO implements MapperSend<IImagenURLDTO> {
    public imagenURl = "";

    obtenerJSON(): IImagenURLDTO {
        return {
            image_url: this.imagenURl
        };
    }
}
